import { toast } from "react-toastify";
import {
  createIspOwnerOLTSuccess,
  deleteIspOwnerOLTSuccess,
  deleteOLTUsersSuccess,
  getCustomerONUSuccess,
  getIspOwnerOLTSuccess,
  getOltEnableVendorsSuccess,
  getOLTUsersSuccess,
  updateIspOwnerOLTSuccess,
  updateOLTUsersSuccess,
} from "./olt.Slice";
import { BASE_URL_NF2 } from "../api/baseURL";
import {
  deleteNetworkPointSuccess,
  getNetworkDiagramSuccess,
  getNetworkPointSuccess,
  postNetworkPointSuccess,
  updateNetworkDeviceOutputSuccess,
} from "./network.slice";

export const createOLT = async (data, setIsLoading, dispatch, setShow) => {
  setIsLoading(true);
  try {
    const res = await BASE_URL_NF2.post("/olt", data);

    dispatch(createIspOwnerOLTSuccess(res.data?.data));
    toast.success(res.data.message);
    setShow(false);
  } catch (error) {
    toast.error(error.message);
  }
  setIsLoading(false);
};

export const updateOLT = async (
  ispOwner,
  data,
  setIsLoading,
  dispatch,
  setShow,
) => {
  setIsLoading(true);
  try {
    const res = await BASE_URL_NF2.patch(`/olt/${ispOwner}/${data?.id}`, data);

    dispatch(updateIspOwnerOLTSuccess(res.data?.data));
    toast.success(res.data.message);
    setShow(false);
  } catch (error) {
    toast.error(error.response?.data?.message);
  }
  setIsLoading(false);
};

export const deleteOLT = async (ispOwner, id, dispatch) => {
  try {
    const res = await BASE_URL_NF2.delete(`/olt/${ispOwner}/${id}`);

    dispatch(deleteIspOwnerOLTSuccess(id));
    toast.success(res.data.message);
  } catch (error) {
    toast.error(error.response?.data?.message);
  }
};

export const getOLT = async (ispOwner, setIsLoading, dispatch) => {
  setIsLoading(true);
  try {
    const res = await BASE_URL_NF2.get(`/olt/${ispOwner}`);

    dispatch(getIspOwnerOLTSuccess(res.data?.data));
  } catch (error) {
    toast.error(error.response?.data?.message);
  }
  setIsLoading(false);
};

export const getOltEnableVendors = async (dispatch, setIsLoading) => {
  setIsLoading(true);
  try {
    const res = await BASE_URL_NF2.get(`olt/enable/vendors`);

    dispatch(getOltEnableVendorsSuccess(res.data?.data));
  } catch (error) {
    toast.error(error.response?.data?.message);
  }
  setIsLoading(false);
};

export const getActiveCustomerONUInformation = async (
  dispatch,
  ispOwner,
  mikrotik,
  macAddress,
  setIsLoading,
  olt = null,
) => {
  setIsLoading(true);
  try {
    const res = await BASE_URL_NF2.get(
      `/olt/${ispOwner}/${mikrotik}/onu-information?olt=${olt}&macAddress=${macAddress}`,
    );

    dispatch(getCustomerONUSuccess(res.data?.data));
  } catch (error) {
    toast.error(error.message);
    dispatch(getCustomerONUSuccess({}));
  }
  setIsLoading(false);
};

export const syncOlSyncOltUsers = async (
  dispatch,
  ispOwner,
  setIsLoading,
  oltId,
) => {
  setIsLoading(true);
  try {
    const url = oltId
      ? `/olt/sync/${ispOwner}?olt=${oltId}`
      : `/olt/sync/${ispOwner}`;

    const res = await BASE_URL_NF2.get(url);

    // dispatch(getCustomerONUSuccess(res.data?.data));
    toast.success(res.data.message);
  } catch (error) {
    toast.error(error.message);
  }
  setIsLoading(false);
};

export const getOltUsers = async (ispOwner, setIsLoading, dispatch) => {
  setIsLoading(true);
  try {
    const res = await BASE_URL_NF2.get(`/olt/users/${ispOwner}`);

    dispatch(getOLTUsersSuccess(res.data?.data));
  } catch (error) {
    toast.error(error.response?.data?.message);
  }
  setIsLoading(false);
};

export const createNetworkPoint = async (
  dispatch,
  data,
  setIsLoading,
  setShow,
) => {
  setIsLoading(true);
  try {
    const res = await BASE_URL_NF2.post("/network", data);

    dispatch(postNetworkPointSuccess(res.data?.data));
    toast.success(res.data.message);
    setShow(false);
  } catch (error) {
    toast.error(error.response?.data?.message);
  }
  setIsLoading(false);
};

export const getNetworkPoint = async (dispatch, ispOwner, setIsLoading) => {
  setIsLoading(true);
  try {
    const res = await BASE_URL_NF2.get(`network/${ispOwner}`);

    dispatch(getNetworkPointSuccess(res.data?.data));
  } catch (error) {
    toast.error(error.response?.data?.message);
  }
  setIsLoading(false);
};

export const deletedNetworkPoint = async (
  dispatch,
  ispOwner,
  network,
  setIsLoading,
) => {
  setIsLoading(true);
  try {
    await BASE_URL_NF2.delete(`network/${ispOwner}/${network}`);

    dispatch(deleteNetworkPointSuccess(network));
  } catch (error) {
    toast.error(error.response?.data?.message);
  }
  setIsLoading(false);
};

export const getNetworkDiagram = async (dispatch, point, setIsLoading) => {
  setIsLoading(true);
  try {
    dispatch(getNetworkDiagramSuccess({}));

    const res = await BASE_URL_NF2.get(`network/diagram/${point}`);
    dispatch(getNetworkDiagramSuccess(res.data?.data));
  } catch (error) {
    toast.error(error.response?.data?.message);
  }
  setIsLoading(false);
};

export const assignNetworkDecice = async (
  dispatch,
  data,
  setIsLoading,
  setShow,
) => {
  setIsLoading(true);
  try {
    const res = await BASE_URL_NF2.post("/network/diagram/device", data);

    dispatch(getNetworkDiagramSuccess(res.data?.data));
    toast.success(res.data.message);
    setShow(false);
  } catch (error) {
    toast.error(error.message);
  }
  setIsLoading(false);
};

export const reassignNetworkDiagramDevice = async (
  dispatch,
  data,
  setIsLoading,
  setShow,
) => {
  setIsLoading(true);
  try {
    const res = await BASE_URL_NF2.patch(`/network/diagram/device`, data);

    dispatch(getNetworkDiagramSuccess(res.data?.data));
    toast.success(res.data.message);
    setShow(false);
  } catch (error) {
    toast.error(error.message);
  }
  setIsLoading(false);
};

export const deleteDeviceFromNetworkDiagram = async (
  dispatch,
  network,
  parent,
  setIsLoading,
) => {
  setIsLoading(true);
  try {
    const res = await BASE_URL_NF2.delete(
      `/network/diagram/device/${network}/${parent}`,
    );

    dispatch(getNetworkDiagramSuccess(res.data?.data));
    toast.success(res.data.message);
  } catch (error) {
    toast.error(error.response?.data?.message);
  }
  setIsLoading(false);
};

export const updateNetworkDeviceOutput = async (
  dispatch,
  output,
  data,
  setIsLoading,
  setShow,
) => {
  setIsLoading(true);
  try {
    const res = await BASE_URL_NF2.patch(`/network/device/${output}`, data);

    dispatch(updateNetworkDeviceOutputSuccess(res.data?.data));
    toast.success(res.data.message);
    setShow(false);
  } catch (error) {
    toast.error(error.message);
  }
  setIsLoading(false);
};

export const getOnuLaserInformation = async (
  dispatch,
  userId,
  setIsLoading,
) => {
  setIsLoading(true);
  try {
    const res = await BASE_URL_NF2.get(`olt/users/laser/${userId}`);

    dispatch(updateOLTUsersSuccess(res.data?.data));
    toast.success(res.data.message);
  } catch (error) {
    toast.error(error.message);
  }
  setIsLoading(false);
};

export const deletedOltUser = async (dispatch, user, setIsLoading) => {
  setIsLoading(true);
  try {
    await BASE_URL_NF2.delete(`olt/users/laser/${user}`);

    dispatch(deleteOLTUsersSuccess(user));
  } catch (error) {
    toast.error(error?.message);
  }
  setIsLoading(false);
};
